import { BranchingQueryDefinition, edgeTypeMatrix, getAllChildEdgeAttributeDefinitions } from '@iotv/datamodel';
import { getChildEdgeTypeId } from '@iotv/datamodel-core';
import { AdjacentType } from '../../types';
const debug = process.env.REACT_APP_DEBUG && false;
/** all types that can be children of the given entity network type */
const getChildTypes = (objectTypeId) => (objectTypeId in edgeTypeMatrix ? Object.keys(edgeTypeMatrix[objectTypeId]) : []);
const getSpecificBranchingQuery = (parentType, childType, edgeTypeId) => {
    return new BranchingQueryDefinition({
        id: `${parentType}_${childType}_${edgeTypeId}`,
        path: [{ objectTypeId: childType, adjacencyType: AdjacentType.CHILD, edgeTypeId }],
        subQueries: [],
    });
};
/** from children of an entity network to their adjacent things */
const getChildAdjacentQueries = (parentType, childType) => {
    const childEdgeTypes = Object.values(getAllChildEdgeAttributeDefinitions(parentType)).filter((d) => d.objectTypeId === childType);
    debug && console.log('getChildAdjacentQueries', 'adjacent', parentType, childType);
    return new BranchingQueryDefinition({
        id: parentType + childType,
        path: [{ objectTypeId: parentType, adjacencyType: AdjacentType.SUBJECT }],
        subQueries: childEdgeTypes.map((e) => getSpecificBranchingQuery(parentType, childType, e.edgeTypeId)),
    });
};
/** from an entity network to children */
const getChildQuery = (entityNetworkType, childType) => {
    const childTypes = getChildTypes(childType).filter((t) => getChildTypes(entityNetworkType).includes(t));
    debug && console.log('getChildQuery', 'child', childType, childTypes);
    return new BranchingQueryDefinition({
        id: childType,
        path: [{ objectTypeId: childType, adjacencyType: AdjacentType.CHILD, edgeTypeId: getChildEdgeTypeId(entityNetworkType, childType) }],
        subQueries: [...childTypes.map((t) => getChildAdjacentQueries(childType, t))],
        // subQueries: [],
    });
};
/** finds full context of an entity network */
export const getEntityNetworkQuery = (entityNetworkType) => {
    const childTypes = getChildTypes(entityNetworkType);
    debug && console.log('getEntityNetworkQuery', 'subject', entityNetworkType, childTypes);
    return new BranchingQueryDefinition({
        id: entityNetworkType,
        path: [{ objectTypeId: entityNetworkType, adjacencyType: AdjacentType.SUBJECT }],
        subQueries: [...childTypes.map((t) => getChildQuery(entityNetworkType, t))],
    });
};
export const getMostProximateVisibleParents = (source, nem, hiddenTypes) => {
    const parents = nem.getParentNodes(source);
    const allVisible = parents.every((p) => !hiddenTypes.includes(p.type));
    if (allVisible)
        return parents;
    const visibleParents = parents.filter((p) => !hiddenTypes.includes(p.type));
    const hiddenParents = parents.filter((p) => hiddenTypes.includes(p.type));
    return [...visibleParents, ...hiddenParents.map((p) => getMostProximateVisibleParents(p, nem, hiddenTypes))].flat();
};
export const getMostProximateVisibleChildren = (source, nem, hiddenTypes) => {
    const children = nem.getChildNodes(source);
    const allVisible = children.every((c) => !hiddenTypes.includes(c.type));
    if (allVisible)
        return children;
    const visibleChildren = children.filter((c) => !hiddenTypes.includes(c.type));
    const hiddenChildren = children.filter((c) => hiddenTypes.includes(c.type));
    return [...visibleChildren, ...hiddenChildren.map((c) => getMostProximateVisibleChildren(c, nem, hiddenTypes))].flat();
};
